import { supportsSelector } from '@js/util/helpers.js'

// Add global class if :focus-visible is not supported
if (!supportsSelector(':focus-visible')) {
  document.documentElement.classList.add('no-focus-visible')
}
